export default {
  en: {
    title: 'Language level',
    subtitleAvailable: 'Level check is available',
    subtitleNext: 'Next check — {{date}}',
    subtitlePremium: 'Next check — {{date}}, with Premium',
    loading: 'Loading level history',
    months: 'Level check month',
    now: 'Now',
    'next.available': 'Take a level check',
    'next.cooldown': 'Next level check is not open yet',
    'next.premium': 'Monthly level checks come with Premium',
    approximate: 'Approximate — you said very little',
    emptyTitle: 'Find out your level in 5 minutes',
    start: 'Check my level',
  },
  ru: {
    title: 'Уровень языка',
    subtitleAvailable: 'Проверка уровня доступна',
    subtitleNext: 'Следующая проверка — {{date}}',
    subtitlePremium: 'Следующая проверка — {{date}}, с Премиумом',
    loading: 'Загружаю историю уровня',
    months: 'Месяц проверки',
    now: 'Сейчас',
    'next.available': 'Пройти проверку уровня',
    'next.cooldown': 'Следующая проверка ещё не открылась',
    'next.premium': 'Ежемесячная проверка — в Премиуме',
    approximate: 'Оценка приблизительная — ты сказал совсем немного',
    emptyTitle: 'Узнай свой уровень за 5 минут',
    start: 'Проверить уровень',
  },
  de: {
    title: 'Sprachniveau',
    subtitleAvailable: 'Niveau-Check ist verfügbar',
    subtitleNext: 'Nächster Check — {{date}}',
    subtitlePremium: 'Nächster Check — {{date}}, mit Premium',
    loading: 'Niveau-Verlauf wird geladen',
    months: 'Monat des Checks',
    now: 'Jetzt',
    'next.available': 'Niveau-Check starten',
    'next.cooldown': 'Der nächste Check ist noch nicht verfügbar',
    'next.premium': 'Monatliche Checks gibt es mit Premium',
    approximate: 'Ungefähr — du hast sehr wenig gesagt',
    emptyTitle: 'Finde dein Niveau in 5 Minuten heraus',
    start: 'Niveau prüfen',
  },
  pt: {
    title: 'Nível do idioma',
    subtitleAvailable: 'Teste de nível disponível',
    subtitleNext: 'Próximo teste — {{date}}',
    subtitlePremium: 'Próximo teste — {{date}}, com Premium',
    loading: 'Carregando histórico de nível',
    months: 'Mês do teste',
    now: 'Agora',
    'next.available': 'Fazer teste de nível',
    'next.cooldown': 'O próximo teste ainda não abriu',
    'next.premium': 'Testes mensais fazem parte do Premium',
    approximate: 'Aproximado — você falou muito pouco',
    emptyTitle: 'Descubra seu nível em 5 minutos',
    start: 'Testar meu nível',
  },
  fr: {
    title: 'Niveau de langue',
    subtitleAvailable: 'Test de niveau disponible',
    subtitleNext: 'Prochain test — {{date}}',
    subtitlePremium: 'Prochain test — {{date}}, avec Premium',
    loading: 'Chargement de l’historique de niveau',
    months: 'Mois du test',
    now: 'Maintenant',
    'next.available': 'Passer le test de niveau',
    'next.cooldown': 'Le prochain test n’est pas encore ouvert',
    'next.premium': 'Les tests mensuels sont inclus dans Premium',
    approximate: 'Approximatif — tu as très peu parlé',
    emptyTitle: 'Découvre ton niveau en 5 minutes',
    start: 'Tester mon niveau',
  },
  es: {
    title: 'Nivel del idioma',
    subtitleAvailable: 'Prueba de nivel disponible',
    subtitleNext: 'Próxima prueba — {{date}}',
    subtitlePremium: 'Próxima prueba — {{date}}, con Premium',
    loading: 'Cargando historial de nivel',
    months: 'Mes de la prueba',
    now: 'Ahora',
    'next.available': 'Hacer la prueba de nivel',
    'next.cooldown': 'La próxima prueba aún no está abierta',
    'next.premium': 'Las pruebas mensuales van con Premium',
    approximate: 'Aproximado — hablaste muy poco',
    emptyTitle: 'Descubre tu nivel en 5 minutos',
    start: 'Comprobar mi nivel',
  },
};
